export default {
  'marketplace.action-msg.generate-label-success': '生成標籤成功',
  'marketplace.action-msg.ack-order-success': '確認市場訂單成功',
  'marketplace.action-msg.cancel-order-success': '取消履行訂單成功',
  'marketplace.action-msg.sync-order-success': '成功同步平台訂單',
  'marketplace.order.tab.all_platform_order': '平台訂單(所有)',
  'marketplace.order.tab.fulfillment_order': 'OMS履行訂單',
  'marketplace.order.tab.fulfillment_order_tooltips': 'OMS履行訂單',
  'marketplace.order.tab.fulfillment_request': '履行請求',
  'marketplace.order.tab.wms_pre_order': '待發送到-WMS',
  'marketplace.order.tab.wms_accepted': '處理中(WMS)',
  'marketplace.order.tab.upload_order': '上傳訂單',
  'marketplace.order.tab.upload_order-for': '上傳訂單(用於建立標籤)',
  'marketplace.order.tab.rejected_label': '失敗 Label',
  'marketplace.order.tab.ready_to_ship': '準備發貨(Label)',
  'marketplace.order.tab.packed_order': '已包裝訂單',
  'marketplace.order.tab.shipped_order': '已發貨訂單',
  'marketplace.order.id': 'ID',
  'marketplace.order.store_account': '店鋪賬號',
  'marketplace.order.title': '平台訂單列表',
  'marketplace.order.platform': '平台',
  'marketplace.order.platform_order_id': '平台訂單ID',
  'marketplace.order.platform_order_no': '平台訂單號碼',
  'marketplace.order.platform_fulfillment_order_id': '平台履約ID',
  'marketplace.order.sync_platform_order_button': '同步平台訂單',
  'marketplace.order.sync_order_date': '同步時間',
  'marketplace.button.show_marketplace_order_fulfillment_detail': '顯示履約詳情',
  'marketplace.button.edit_shipping_button': '修改發貨信息',
  'marketplace.order.new_platform_fulfillment_title': '新訂單履約詳情',
  'marketplace.order.update_shipping_address': '修改訂單 #{platformOrderId} 發貨信息',
  'marketplace.order.update-shipping-address.fail': '修改發貨信息失敗!',
  'marketplace.order.push_wms_success': '推送WMS成功',
  'marketplace.order.push_wms_failed': '推送WMS失敗',
  'marketplace.order.push_generate_waybill_success': '推送成功',
  'marketplace.order.push_generate_waybill_failed': '推送失敗',
  'marketplace.order.purchase_date': '購買時間',
  'marketplace.order.latest_pickup_date': '提貨日期',
  'marketplace.order.purchase_date_from': '從購買時間',
  'marketplace.order.currency': '貨幣',
  'marketplace.order.number_of_sku_qty': '訂單總數量',
  'marketplace.order.fulfillment_location_name': '平台履約地點',
  'marketplace.order.platform_fulfillment_status': '平台履約狀態',
  'marketplace.order.platform_payment_status': '平台支付狀態',
  'marketplace.order.platform_order_status': '平台訂單狀態',
  'marketplace.order.total_commission': '佣金总额',
  'marketplace.order.label_status': '運單狀態',
  'marketplace.order.download-all-to-label': '下載 (所有)',
  'marketplace.order.status': '狀態',
  'marketplace.order.basic-info': '基本信息',
  'marketplace.order.marketplace_store': '平台店鋪',
  'marketplace.order.total_amount': '總金額',
  'marketplace.order.shipping_fee': 'Shipping Fee',
  'marketplace.order.shipping_fee_original': 'Shipping Fee original',
  'marketplace.order.shipping_fee_discount': 'Shipping Fee Discount',
  'marketplace.order.total_tax': 'Total Tax',
  'marketplace.order.voucher_amount': 'Voucher Amount',
  'marketplace.order.voucher_platform': 'Voucher Platform',
  'marketplace.order.voucher_seller': 'Voucher Seller',
  'marketplace.order.payment_method': 'Payment Method',
  'marketplace.order.buyer_note': 'Buyer Note',
  'marketplace.order.gift_option': 'Gift Option',
  'marketplace.order.remark': 'Remark',
  'marketplace.order.bill-info': '賬單信息',
  'marketplace.order.bill_name': '賬單名稱 ',
  'marketplace.order.bill_phone': '賬單電話',
  'marketplace.order.bill_postal_code': '賬單郵編',
  'marketplace.order.bill_country': '賬單國家',
  'marketplace.order.bill_city': '賬單城市',
  'marketplace.order.bill_district': '賬單地區',
  'marketplace.order.bill_address': '賬單地址',
  'marketplace.order.shipping-info': '發貨信息',
  'marketplace.order.shipping_name': ' 寄件名稱',
  'marketplace.order.shipping_phone': '寄件電話',
  'marketplace.order.shipping_postal_code': '郵遞區號',
  'marketplace.order.shipping_country': '寄件國家',
  'marketplace.order.shipping_city': '寄件城市',
  'marketplace.order.shipping_district': '寄件地區',
  'marketplace.order.shipping_address': '寄件地址',
  'marketplace.order.order_item_id': '訂單物品ID',
  'marketplace.order.product_name': '產品名稱',
  'marketplace.order.seller_sku': '產品 SKU',
  'marketplace.order.quantity_ordered': '訂購數量',
  'marketplace.order.shipping_type': '發貨類型',
  'marketplace.order.item_price': '物品價格',
  'marketplace.order.unit_price': '單價',
  'marketplace.order.require_fulfillment_qty': '需要履約數量',
  'marketplace.order.fulfillment_qty': '已履約數量',
  'marketplace.order.weight': '重量',
  'marketplace.order.country_of_origin': '產地 (COO)',
  'marketplace.order.item_declared_value': '申報價格',
  'marketplace.order.hscode': 'HS Code',
  'marketplace.order.shipping_price': '運費',
  'marketplace.order.item-info': '訂單物品詳情',
  'marketplace.order.detail.title': '訂單 ',
  'marketplace.order.to_country': '到達國家',
  'marketplace.order.declared_value': '申報價格',
  'marketplace.order.sync_orders': '同步平台訂單',
  'marketplace.order.sync_orders.tooltip': '同步平台訂單',
  'marketplace.order.button.sync_orders': '同步平台訂單',
  'marketplace.order.item.no': 'No.',
  'marketplace.order.weight.tooltip': '重量單位(G)',
  'marketplace.order.item_declared_value.tooltip': '申報價格(每件物品)',
  'marketplace.order.create_label_success_title': '創建運單成功',
  'marketplace.order.create_shipment.title': '創建訂單號{document_no}-運單',
  'marketplace.order.re_create_shipment.title': '重新創建訂單號{document_no}-運單',
  'marketplace.order.edit_shipment.title': '編輯訂單號{document_no}-運單',
  'marketplace.button.create_label': '創建運單',
  'marketplace.order.create_label.fail': '創建運單失敗, 請檢查',
  'marketplace.order.create_label.success': '創建運單已經成功，請查看',
  'marketplace.order.shipped.success': '訂單發貨成功',
  'marketplace.order.dispatch-shipping-confirm': '你真的想要把選中的訂單發貨嗎?',
  'marketplace.order.mark_as_shipped_orders': '標記已發貨',
  'fulfillment.order.shipped_success': '標記成功',
  'fulfillment.order.shipped_failed': '標記失敗',
  'marketplace.order.print_picklist_label': '打印揀貨單',
  'marketplace.button.send_to_wms': '發送到 WMS',
  'marketplace.order.send-to-wms-confirm': '妳真的想要把選中的履行訂單發送到WMS出庫嗎?',
  'marketplace.tooltip.acknowledge-order': '確認訂單',
  'marketplace.acknowledge-order-confirm': '妳真的想要確認這個訂單嗎?',
  'marketplace.order.shipment-info': '訂單運輸信息',
  'marketplace.order.shipment_reference_no': '運單參考編號',
  'marketplace.order.service_code': '物流產品服務編碼',
  'marketplace.order.incoterm': 'Incoterm',
  'marketplace.order.shipment_content': '運輸內容',
  'marketplace.order.tracking_no': '跟蹤號碼',
  'marketplace.order.delivery_email': '收件人E-mail',
  'marketplace.order.delivery_name': '收件人名稱',
  'marketplace.order.delivery_company': '收件人公司',
  'marketplace.order.delivery_address': '收件人地址',
  'marketplace.order.delivery_state': '收件人州/省',
  'marketplace.order.delivery_postal': '收件人郵編',
  'marketplace.order.delivery_country': '收件人國家',
  'marketplace.order.delivery_phone': '收件人電話',
  'marketplace.order.delivery_city': '收件人地址',
  'marketplace.order.packed_at': '打包時間',
  'marketplace.order.shipped_at': '發貨時間',
  'marketplace.button.re_create_label': '重新生成運單',
  'marketplace.order.shipment_by_system': '運單創建人',
  'marketplace.sync-shipping': '同步發貨信息',
  'marketplace.sync-shipping-info-confirm': '你真的想要同步訂單的發貨信息嗎?',
  'marketplace.upload-order.instruction-1': '*此處成功建立的出貨資料將自動儲存在出貨摘要中。',
  'marketplace.upload-order.instruction-2': '*建議每批最多上傳250行資料。',
  'marketplace.upload-order.instruction-3':
    '*數據格式要求：請確保上傳的文件符合系統要求的數據格式。具體格式說明請參考系統提供的模板。',
  'marketplace.upload-order.instruction-4':
    '*如需上傳大量數據，請聯絡我們的客戶服務專線：2648 8902。',
  'marketplace.order.external_fulfillment_status': '外部履行状态',
  'marketplace.order.fulfillment_wms_title': '履行訂單',
  'marketplace.order.fulfillment_title': '履行訂單',
  'marketplace.order.fulfillment-to-wms-outbound': '通過WMS履行',
  'marketplaces.common.select-order-first': '請先選擇新訂單，然後再點擊下載',
  'marketplace.order.fulfillment-to-generate-waybill': '自行發貨（只生成運單）',
  'marketplace.order.fulfillment_generate_waybill_title': '自行發貨（只生成運單）',
  'marketplace.download_selected_oms_accepted': '下載已選擇的OMS新訂單',
  'marketplace.order.create_multi_piece_button': '一票多件',
  'marketplace.order.create_one_piece_button': '一票一件',
  'marketplace.order.boxed_qty': '已分配到包裹數量',
  'marketplace.order.total_ordered_quantity': '總訂購數量',
  'marketplace.order.total_item_price': '總價格',
  'marketplace.order.subtotal': 'Subtotal',
  'marketplace.order.net_item_value': 'Net Item Value',
  'marketplaces.oms_accepted.selected_different_hk_country':
    '本地訂單(香港)不能與其他國家一起選擇發貨',
  'fulfillment.order.packages-item-info': '包裹物品詳情',
  'fulfillment.order.shipment_reference_no': '履行訂單參考編號',
  'fulfillment.order.courier_service_code': '物流產品服務編碼',
  'fulfillment.order.sku': '產品 SKU',
  'fulfillment.order.product_name': '產品名稱',
  'fulfillment.order.quantity': '數量',
  'fulfillment.order.wms_merchant_code': 'WMS 貨主',
  'fulfillment.order.wms_warehouse_code': 'WMS 倉庫',
  'fulfillment.order.wms_delivery_note_code': 'WMS 出庫號',
  'fulfillment.order.show_fulfillment_detail': '查看履行訂單詳情',
  'fulfillment.order.no-available-item-to-add-new-package': '已經沒有可用的項目添加到新的包裹',
  'fulfillment.order.add-new-package-button': '添加新包裹',
  'fulfillment.order.cancel-confirm': '您確定要取消{document_no}此履行訂單嗎？',
  'fulfillment.order.request_pickup_date': '提貨時間',
  'fulfillment.order.ready_to_ship_date_at': '準備發貨時間',
  'fulfillment.order.shipped_date_at': '發貨時間',
  'fulfillment.order.platform_transporter': 'Platform Transporter',
  'fulfillment.order.tracking_url': 'Tracking URL',
  'fulfillment.order.error_message': '錯誤信息',
  'fulfillment.order.subtotal': '小結',
  'fulfillment.order.total_quantity': '總數量',
  'fulfillment.order.total_weight': '總重量',
  'fulfillment.order.total_declared_value': '總申報價格',
  'fulfillment.order.outbound_strategy': '出庫策略',
  'fulfillment.order.pending_to_ready_button': '選擇出庫策略',
  'fulfillment.order.fulfillment_pending_to_ready_title': '設置出庫策略',
  'fulfillment.order.outbound_type_wms': '通過WMS倉庫出庫',
  'fulfillment.order.outbound_type_label': '只下載運單，自行出庫',
  'fulfillment.order.multi_piece_basic_title': '運單基本信息',
  'fulfillment.order.multi_piece_pacakge_title': '一票多件(包裹詳情)',
  'fulfillment.order.send_to_wms.success': '已經成功發送出貨單到WMS',
  'fulfillment.request.button.download_waybill': '下載運單',
  'fulfillment.order.oms_order_reference': 'OMS Order Reference',
  'fulfillment.order.item.oms_po_reference': 'PO Reference',
  'fulfillment.order.oms_order_type': 'OMS Order Type',
  'fulfillment.order.external_sap_status': 'External SAP Status',
  'fulfillment.request.external_status': 'External WMS Status',
  'fulfillment.button.send-sap-order': 'Send To SAP',
  'fulfillment.order.send-sap-order-confirm': 'Are you sure to send this {document_no} fulfilment order to SAP?',
  'fulfillment.button.send-wms-label': 'Send To WMS Waybill',
  'fulfillment.request.send-wms-label-confirm': 'Are you sure to send this {document_no} waybill to External WMS?',
  'fulfillment.button.cancel-stock-order': 'Cancel OMS Stock',
  'fulfillment.order.cancel-stock-order-confirm': 'Are you sure to cancel the OMS stock for the platform order {document_no}?',
  'fulfillment.button.allocated-stock-label': 'Allocate OMS Stock',
  'fulfillment.order.allocated-stock-order-confirm': 'Are you sure to allocate the OMS stock for the platform order {document_no}?',
  'fulfillment.button.pack-stock-order': 'Pack OMS Stock',
  'fulfillment.order.pack-stock-order-confirm': 'Are you sure to pack the OMS stock for the platform order {document_no}?',
  'fulfillment.order.oms_cancel_flow': 'Cancel Flow',
  'fulfillment.order.oms_cancel_status': 'OMS Cancel Status',
  'order.step.new_order_at': 'New',
  'order.step.oms_accepted_at': 'OMS Accepted',
  'order.step.send_to_sap_at': 'Send TO SAP',
  'order.step.send_to_wms_label_at': 'Send Waybill To WMS',
  'order.step.client_ready_to_ship_at': 'Ready To Ship (SAP)',
  'order.step.client_request_cancel_at': 'Exception (SAP)',
  'order.step.wms_shipped_at': 'Shipped',
  'order.step.delivered_at': 'Delivered',
};
